import { Skeleton } from '@/components/ui/skeleton';

export function LineDetailsSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-9 w-32 rounded-xl" />
      <div className="rounded-2xl bg-white p-8 shadow-sm space-y-6">
        <div className="flex items-center gap-4">
          <Skeleton className="h-10 w-56" />
          <Skeleton className="h-7 w-20 rounded-full" />
        </div>
        <Skeleton className="h-5 w-64" />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-16 rounded-xl" />
          ))}
        </div>
      </div>
      <Skeleton className="h-10 w-80 rounded-lg" />
      <div className="rounded-2xl bg-white p-6 shadow-sm space-y-4">
        <Skeleton className="h-6 w-40" />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-24 rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  );
}
